import React from "react";
import Teams from "../../../../api/Teams";
import { numericSuffix } from "../../../../services/utils";
import _ from "lodash";
import { Popover, OverlayTrigger } from "react-bootstrap";

const popoverComponent = product => {
  return (
    <Popover
      id={`popover-product-features-${product.product.id}`}
      title="Product's Features"
      bsClass="map-popover popover"
    >
      <b>Resolution:</b> {product.product.pixels_rank}
      <br />
      <b>Sensitivity:</b> {product.product.sensitivity_rank}
      <br />
      <b>Power:</b> {product.product.power_rank}
      <br />
      <b>Temperature:</b> {product.product.temp_range_rank}
    </Popover>
  );
};

function TopProductsMobile({ teams = [], top_performers = {} }) {
  const colors = Teams.competitiveColors();
  let top_products = [];
  if ("Mobile" in top_performers) {
    // Drop rank_mobile === 0 entries — BE tags products with no
    // interested Mobile customers with a zero rank + a `note` field,
    // and they shouldn't compete for a "Top ranked" slot in this
    // segment.
    top_products = top_performers.Mobile.filter(i => i.rank_mobile !== 0);
  }

  if (top_products.length > 0) {
    const top_products_rank_1 = top_products.filter(i => i.rank_mobile === 1);

    if (top_products.length === top_products_rank_1.length) {
      if (top_products.length > 7) {
        top_products = _.shuffle(top_products);
        top_products = top_products.slice(0, 7);
      }
    } else {
      top_products.sort((a, b) => {
        return a.rank_mobile - b.rank_mobile;
      });
    }
  }

  if (top_products.length > 7) {
    top_products = top_products.slice(0, 7);
  }

  return (
    <div className="col-md-4 col-xs-12">
      <div className="bg-white p-30 mh-230">
        <h5 className="text-center">TOP RANKED PRODUCTS MOBILE</h5>
        <div className="panel-dashboard-white mt-30 text-center">
          {top_products.length > 0 && (
            <div className="table-responsive">
              <table className="table table-top-list">
                <tbody>
                  {top_products.map((product, num) => {
                    let index = 0;
                    Object.keys(teams).forEach((id, i) => {
                      let idNum = parseInt(id, 10);
                      if (isNaN(idNum)) {
                        idNum = 0;
                      }
                      if (product.team === idNum) {
                        index = i;
                      }
                    });
                    const squareStyle = {
                      display: "inline-block",
                      width: 15,
                      height: 15,
                      backgroundColor: colors[index % colors.length]
                    };

                    return (
                      <tr className="text-center" key={product.product.id}>
                        <td className="short-column">
                          {numericSuffix(num + 1)}
                        </td>
                        <td className="short-column">
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="bottom"
                            overlay={popoverComponent(product)}
                          >
                            <span style={squareStyle} />
                          </OverlayTrigger>
                        </td>
                        <td>{product.product.name}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {top_products.length === 0 && (
            <div className="text-center no-products">
              No Product in the Market
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TopProductsMobile;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/top-products-mobile.js